import ApiService from './api'

const BASE = 'modelos-pecas/rag/judit'
const idPath = (id) => encodeURIComponent(id)
const post = (path, body, signal) => ApiService.request(`${BASE}/${path}`, {
  method: 'POST', body: JSON.stringify(body), signal, retryOnAuthFailure: false, timeoutMs: 120000,
})

const JuditProcessos = {
  configuration: (signal) => ApiService.request(`${BASE}/configuracao`, { signal, cache: 'no-store' }),
  listByProcess: (numeroProcesso, signal) => post('consultas/por-processo/listar', { numeroProcesso }, signal),
  openByProcess: ({ numeroProcesso, instancia, publicacao }, signal) => post('consultas/por-processo', {
    numeroProcesso, ...(instancia ? { instancia } : {}), ...(publicacao ? { publicacao } : {}),
  }, signal),
  synchronizeProcess: ({ numeroProcesso, requestId, instancia, consultaId, versao }, signal) => post('consultas/por-processo/sincronizar', {
    numeroProcesso, requestId, ...(instancia ? { instancia } : {}), ...(consultaId ? { consultaId, versao } : {}),
  }, signal),
  create: ({ numeroProcesso, instancia, requestId }, signal) => post('consultas', { numeroProcesso, instancia, requestId }, signal),
  get: (id, signal) => ApiService.request(`${BASE}/consultas/${idPath(id)}`, { signal, cache: 'no-store' }),
  getByRequest: (requestId, signal) => ApiService.request(`${BASE}/consultas/por-solicitacao/${idPath(requestId)}`, { signal, cache: 'no-store' }),
  refresh: (id, versao, signal) => post(`consultas/${idPath(id)}/atualizar`, { versao }, signal),
  download: (id, versao, anexoId, signal) => post(`consultas/${idPath(id)}/documentos`, { versao, anexoId }, signal),
  reextract: (id, versao, anexoId, signal) => post(`consultas/${idPath(id)}/documentos/reextrair`, { versao, anexoId, autorizarNovoDownload: true }, signal),
  text: (id, documentoId, signal) => ApiService.request(`${BASE}/consultas/${idPath(id)}/documentos/${idPath(documentoId)}/texto`, { signal, cache: 'no-store' }),
}

export default JuditProcessos
